module.exports = __webpack_public_path__ + "fonts/proximanovasoft-regular-webfont.be0068b.woff";